/**
 * buildCopies — MADE-297
 *
 * For N copies of a count sheet, each copy gets ⌈total × 1.2 / N⌉ items
 * (capped at total). Items shuffle randomly; each copy takes a contiguous
 * slice starting at ⌊i × total / N⌋ (wrapping), giving ~20% overlap.
 *
 * @param items  Array of items; each must have an `itemNumber` field.
 * @param n      Number of copies to produce.
 * @returns      Array of n item arrays (each a subset of items).
 */
export function buildCopies<T extends { itemNumber: number | string }>(items: T[], n: number): T[][] {
  if (n <= 1) return [items];
  const shuffled = [...items].sort(() => 0.5 - Math.random());
  const total = shuffled.length;
  const copySize = Math.min(total, Math.ceil(total * 1.2 / n));
  return Array.from({ length: n }, (_, i) => {
    const start = Math.floor(i * total / n);
    const indices = Array.from({ length: copySize }, (_unused, j) => (start + j) % total);
    const unique = [...new Set(indices)].map(idx => shuffled[idx]);
    return unique.sort((a, b) => Number(a.itemNumber) - Number(b.itemNumber));
  });
}
